import * as XLSX from "xlsx";

/**
 * Sheet definitions matching UI sections.
 * Each sheet has its own columns for maximum readability.
 */
const SHEET_DATA = {
  Property: {
    cols: [{ wch: 35 }, { wch: 40 }],
    rows: [{ "Final URL": "https://example.com", "Business Name (max characters 25)": "My Business Name" }],
  },
  Headlines: {
    cols: [{ wch: 40 }],
    rows: [
      { "Headline (max characters 30)": "Example Headline 1" },
      { "Headline (max characters 30)": "Example Headline 2" },
      { "Headline (max characters 30)": "Example Headline 3" },
    ],
  },
  Descriptions: {
    cols: [{ wch: 60 }],
    rows: [
      { "Description (max characters 90)": "Example description text up to 90 characters." },
      { "Description (max characters 90)": "Another description for your ad creative." },
    ],
  },
  "Site Link Extensions": {
    cols: [{ wch: 40 }, { wch: 45 }, { wch: 45 }, { wch: 45 }],
    rows: [
      {
        "Sitelink Text (max characters 25)": "My Sitelink",
        "Sitelink Description 1 (max characters 25)": "Sitelink desc line 1",
        "Sitelink Description 2 (max characters 25)": "Sitelink desc line 2",
        "Sitelink final url (max characters 25)": "https://example.com/page",
      },
      {
        "Sitelink Text (max characters 25)": "Another Link",
        "Sitelink Description 1 (max characters 25)": "Description line 1",
        "Sitelink Description 2 (max characters 25)": "Description line 2",
        "Sitelink final url (max characters 25)": "https://example.com/other",
      },
    ],
  },
  "Callout Extensions": {
    cols: [{ wch: 35 }],
    rows: [
      { "Callouts (max characters 25)": "Free Shipping" },
      { "Callouts (max characters 25)": "24/7 Support" },
    ],
  },
  "Structured Snippets": {
    cols: [{ wch: 35 }],
    rows: [
      { "Snippet (max character 25)": "Amenities: Pool, Spa" },
      { "Snippet (max character 25)": "Rooms: Suite, Deluxe" },
    ],
  },
  Calls: {
    cols: [{ wch: 20 }, { wch: 15 }],
    rows: [{ "Phone Number": "+14155551234", "Country Code": "US" }],
  },
  "Display Path": {
    cols: [{ wch: 35 }, { wch: 35 }],
    rows: [{ "Display Path 1 (max character 15)": "hotels", "Display Path 2 (max character 15)": "luxury" }],
  },
};

/**
 * Flat single-sheet layout for CSV (since CSV cannot have multiple sheets).
 */
const CSV_ROWS = [
  { section: "Property", "Final URL": "https://example.com", "Business Name (max characters 25)": "My Business Name", "Headline (max characters 30)": "", "Description (max characters 90)": "", "Sitelink Text (max characters 25)": "", "Sitelink Description 1 (max characters 25)": "", "Sitelink Description 2 (max characters 25)": "", "Sitelink final url (max characters 25)": "", "Callouts (max characters 25)": "", "Snippet (max character 25)": "", "Phone Number": "", "Country Code": "", "Display Path 1 (max character 15)": "", "Display Path 2 (max character 15)": "" },
  { section: "Headlines", "Final URL": "", "Business Name (max characters 25)": "", "Headline (max characters 30)": "Example Headline 1", "Description (max characters 90)": "", "Sitelink Text (max characters 25)": "", "Sitelink Description 1 (max characters 25)": "", "Sitelink Description 2 (max characters 25)": "", "Sitelink final url (max characters 25)": "", "Callouts (max characters 25)": "", "Snippet (max character 25)": "", "Phone Number": "", "Country Code": "", "Display Path 1 (max character 15)": "", "Display Path 2 (max character 15)": "" },
  { section: "Headlines", "Final URL": "", "Business Name (max characters 25)": "", "Headline (max characters 30)": "Example Headline 2", "Description (max characters 90)": "", "Sitelink Text (max characters 25)": "", "Sitelink Description 1 (max characters 25)": "", "Sitelink Description 2 (max characters 25)": "", "Sitelink final url (max characters 25)": "", "Callouts (max characters 25)": "", "Snippet (max character 25)": "", "Phone Number": "", "Country Code": "", "Display Path 1 (max character 15)": "", "Display Path 2 (max character 15)": "" },
  { section: "Descriptions", "Final URL": "", "Business Name (max characters 25)": "", "Headline (max characters 30)": "", "Description (max characters 90)": "Example description text", "Sitelink Text (max characters 25)": "", "Sitelink Description 1 (max characters 25)": "", "Sitelink Description 2 (max characters 25)": "", "Sitelink final url (max characters 25)": "", "Callouts (max characters 25)": "", "Snippet (max character 25)": "", "Phone Number": "", "Country Code": "", "Display Path 1 (max character 15)": "", "Display Path 2 (max character 15)": "" },
  { section: "Site Link Extensions", "Final URL": "", "Business Name (max characters 25)": "", "Headline (max characters 30)": "", "Description (max characters 90)": "", "Sitelink Text (max characters 25)": "My Sitelink", "Sitelink Description 1 (max characters 25)": "Desc line 1", "Sitelink Description 2 (max characters 25)": "Desc line 2", "Sitelink final url (max characters 25)": "https://example.com/page", "Callouts (max characters 25)": "", "Snippet (max character 25)": "", "Phone Number": "", "Country Code": "", "Display Path 1 (max character 15)": "", "Display Path 2 (max character 15)": "" },
  { section: "Callout Extensions", "Final URL": "", "Business Name (max characters 25)": "", "Headline (max characters 30)": "", "Description (max characters 90)": "", "Sitelink Text (max characters 25)": "", "Sitelink Description 1 (max characters 25)": "", "Sitelink Description 2 (max characters 25)": "", "Sitelink final url (max characters 25)": "", "Callouts (max characters 25)": "Free Shipping", "Snippet (max character 25)": "", "Phone Number": "", "Country Code": "", "Display Path 1 (max character 15)": "", "Display Path 2 (max character 15)": "" },
  { section: "Structured Snippets", "Final URL": "", "Business Name (max characters 25)": "", "Headline (max characters 30)": "", "Description (max characters 90)": "", "Sitelink Text (max characters 25)": "", "Sitelink Description 1 (max characters 25)": "", "Sitelink Description 2 (max characters 25)": "", "Sitelink final url (max characters 25)": "", "Callouts (max characters 25)": "", "Snippet (max character 25)": "Amenities: Pool, Spa", "Phone Number": "", "Country Code": "", "Display Path 1 (max character 15)": "", "Display Path 2 (max character 15)": "" },
  { section: "Calls", "Final URL": "", "Business Name (max characters 25)": "", "Headline (max characters 30)": "", "Description (max characters 90)": "", "Sitelink Text (max characters 25)": "", "Sitelink Description 1 (max characters 25)": "", "Sitelink Description 2 (max characters 25)": "", "Sitelink final url (max characters 25)": "", "Callouts (max characters 25)": "", "Snippet (max character 25)": "", "Phone Number": "+14155551234", "Country Code": "US", "Display Path 1 (max character 15)": "", "Display Path 2 (max character 15)": "" },
  { section: "Display Path", "Final URL": "", "Business Name (max characters 25)": "", "Headline (max characters 30)": "", "Description (max characters 90)": "", "Sitelink Text (max characters 25)": "", "Sitelink Description 1 (max characters 25)": "", "Sitelink Description 2 (max characters 25)": "", "Sitelink final url (max characters 25)": "", "Callouts (max characters 25)": "", "Snippet (max character 25)": "", "Phone Number": "", "Country Code": "", "Display Path 1 (max character 15)": "hotels", "Display Path 2 (max character 15)": "luxury" },
];

/**
 * Download a template file.
 * XLSX: Multi-sheet workbook with one sheet per UI section.
 * CSV: Single sheet with section column.
 * @param {"csv"|"xlsx"} format
 */
export const downloadTemplate = (format = "xlsx") => {
  const workbook = XLSX.utils.book_new();

  if (format === "csv") {
    const worksheet = XLSX.utils.json_to_sheet(CSV_ROWS);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Ad Creatives");
    XLSX.writeFile(workbook, "ad_creatives_template.csv", { bookType: "csv" });
  } else {
    Object.entries(SHEET_DATA).forEach(([sheetName, { cols, rows }]) => {
      const worksheet = XLSX.utils.json_to_sheet(rows);
      worksheet["!cols"] = cols;
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    });
    XLSX.writeFile(workbook, "ad_creatives_template.xlsx");
  }
};